/**
 * Charge Size (lbs) threshold that governs Monitoring Start Date / Monitoring
 * Duration availability:
 *  - >= threshold: fields are disabled and submitted as null
 *  - < threshold : fields are enabled and optional
 */
export const CHARGE_SIZE_THRESHOLD = 1500;

/**
 * Allowed Charge Size (lbs) range for the Monitoring Request form.
 */
export const CHARGE_SIZE_MIN = 1;
export const CHARGE_SIZE_MAX = 5000;

export const CHARGE_SIZE_RANGE_INVALID_MESSAGE =
    `Charge Size must be between ${CHARGE_SIZE_MIN} and ${CHARGE_SIZE_MAX}`;

/**
 * Monitoring Start Date display/parse format used across the form.
 */
export const MONITORING_START_DATE_FORMAT = "MM-DD-YYYY";

/**
 * Fixed earliest allowed Monitoring Start Date per business rule:
 * "Start Date cannot be prior to a year or 09/15/2026"
 */
export const MONITORING_START_DATE_FLOOR = new Date(2026, 8, 15);

export const MONITORING_START_DATE_INVALID_MESSAGE =
    "Error \u2013 Monitoring Start Date must be on or after 09/15/2026";

/**
 * Monitoring Start Date cannot be more than 1 year in the past. This check is
 * evaluated before the fixed-floor check above so that, when a selected date
 * violates both rules, the user sees the more specific "too old" message.
 */
export const MONITORING_START_DATE_TOO_OLD_MESSAGE =
    "Error \u2013 Monitoring Start Date cannot be more than 1 year in the past";

/**
 * Shown when the Monitoring Start Date value (e.g. provided via URL query
 * param) cannot be parsed as a valid date at all.
 */
export const MONITORING_START_DATE_INVALID_FORMAT_MESSAGE =
    "Error \u2013 Monitoring Start Date is not a valid date";
